import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import LoginWelcome from "./LoginWelcome";

export default function LoginWelcomeGate({ children }) {
  const { user, branding, welcomeSession, finishWelcome, logout } = useAuth();
  const navigate = useNavigate();
  const done = useCallback(() => {
    finishWelcome();
    navigate(user?.role?.startsWith("finance_") ? "/finance" : "/", {replace: true});
  }, [finishWelcome, navigate, user?.role]);
  if (!user || welcomeSession?.userId !== user.id) return children;
  // Modal ganti password milik AuthContext tetap mendapatkan prioritas.
  if (user.must_change_password) return <main className="eh-welcome"><p>Selesaikan penggantian kata sandi untuk melanjutkan.</p></main>;
  return <LoginWelcome key={`${user.id}:${welcomeSession.startedAt}`} user={user} branding={branding} onDone={done} onLogout={logout} />;
}
